import gql from 'graphql-tag';

const GetTeams = gql`
  query GetTeams($organisationId: String!) {
    getTeams(organisationId: $organisationId) {
      teamId
      name
    }
  }
`;

export default ((organisationId) => ({
  query: GetTeams,
  module: 'users',
  ignoreCache: true,
  buildVariables: () => ({
    organisationId
  })
}));